import { render, staticRenderFns } from "./editAnnouncementBanner.vue?vue&type=template&id=cb5aa882&lang=pug"
import script from "./editAnnouncementBanner.vue?vue&type=script&lang=js"
export * from "./editAnnouncementBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports